const statusColors: { [key: string]: string } = {
  Success: "shipped",
  Pending: "pending",
  Progress: "progress",
  Finished: "Finished",
  shipped: "shipped",
  Draft: "draft",
  Rejected: "rejected",
  Cancelled: "cancelled",
  In: "shipped",
  created: "created",
  updated: "updated",
  deleted: "deleted",
  Out: "rejected",
  active: "created",
  inactive: "rejected",
}

export default function StatusBadge({ name }: { name: string }) {
  const color = statusColors[name] || ""

  return <div className={`trezo-badge ${color}`}>{name}</div>
}
